import { computed } from 'vue'
import { useAppStore } from '@/stores/app'

/**
 * Inline bilingual helper — mirrors the mockup's tr(zh, en) function.
 * Use when the string only appears in this one component (most of the UI).
 * For shared strings (router meta, breadcrumb keys), use vue-i18n via locales/*.json.
 */
export function useTr() {
  const app = useAppStore()
  const tr = (zh: string, en: string) => (app.locale === 'en' ? en : zh)
  const locale = computed(() => app.locale)
  return { tr, locale }
}
